import LanguageSwitch from './component'

export default LanguageSwitch